import { render, staticRenderFns } from "./ListaSimuladosView.vue?vue&type=template&id=ead7bb56&scoped=true&"
import script from "./ListaSimuladosView.vue?vue&type=script&lang=js&"
export * from "./ListaSimuladosView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ead7bb56",
  null
  
)

export default component.exports